import React, { useState } from 'react';
import { View, ScrollView, TextInput } from 'react-native';
import { TextInputMask } from 'react-native-masked-text';
import Icon from 'react-native-vector-icons/Ionicons';

import { useDispatch, useSelector } from 'react-redux';
import { GreenButton } from '../../../components/derivative';
import { AppHeader } from '../../../components/common';
import { AppText, AppSelector } from '../../../components/form';
import { pixelDimensions } from '../../../config/utils';
import styles from './styles';
import { WorkerActions } from '../../../redux/reducers/workerReducer';

const LevelTwo = ({ navigation }) => {
  const dispatch = useDispatch();
  const { pnfamData } = useSelector((state) => state.worker);

  const [levelTwoParams, updateL2Params] = useState({
    disconfort: '',
    pain: '',
    posture: '',
    tiredness: undefined,
  });
  const optionsYesNo = [
    { label: 'SIM', value: 1 },
    { label: 'NÃO', value: 0 },
  ];

  const nextPage = () => {
    const data = {
      ...pnfamData,
      desconforto_fisico: levelTwoParams.disconfort,
      dor_constante: levelTwoParams.pain,
      posture: levelTwoParams.posture,
      tiredness: levelTwoParams.tiredness,
    };
    dispatch({ type: WorkerActions.UPDATE_DATA, dataType: 'pnfamData', dataValue: { ...data } });
    navigation.navigate('Worker Level Three');
  };
  return (
    <View style={styles.viewBase}>
      <AppHeader title="Caraterísticas Fisiológicas" hasBack navigation={navigation} />
      <View style={styles.content}>
        <ScrollView style={styles.scroll}>
          <View style={styles.viewL2Params}>
            <AppText size="bold" style={styles.textClassify}>{'ALGUM DESCONFORTO FÍSICO\nNOS ÚLTIMOS 5 DIAS? QUAL?'}</AppText>
            <TextInput value={levelTwoParams.disconfort} onChangeText={(disconfort) => updateL2Params({ ...levelTwoParams, disconfort })} multiline numberOfLines={2} style={[styles.input, styles.inputNoIcon]} />
            <AppText size="bold" style={styles.textClassify}>{'ALGUMA DOR CONSTANTE\nNO CORPO? QUAL?'}</AppText>
            <TextInput value={levelTwoParams.pain} onChangeText={(pain) => updateL2Params({ ...levelTwoParams, pain })} multiline numberOfLines={2} style={[styles.input, styles.inputNoIcon]} />
            <AppText size="bold" style={styles.textClassify}>{'COLOQUE UMA NOTA DE 0 A 10\nPARA AVALIAR A QUALIDADE DA SUA\nPOSTURA NOS ÚLTIMOS 5 DIAS.'}</AppText>
            <TextInputMask type="only-numbers" maxLength={2} value={levelTwoParams.posture} onChangeText={(posture) => updateL2Params({ ...levelTwoParams, posture })} style={[styles.input, styles.inputNoIcon]} />
            <AppText size="bold" style={styles.textClassify}>{'TEM CANSAÇO FÍSICO NO FINAL DA\nSUA JORNADA DE TRABALHO'}</AppText>
            <AppSelector
              options={optionsYesNo}
              optionValue="value"
              optionText="label"
              target="tiredness"
              changeData={(target, value) => updateL2Params({ ...levelTwoParams, [target]: value })}
              fieldValue={levelTwoParams.tiredness}
            />
          </View>
          <GreenButton
            label={(
              <AppText size="bold" style={styles.textButtonGreen}>
                AVANÇAR
                <Icon style={{ fontSize: pixelDimensions(5) }} name="chevron-forward" />
              </AppText>
)}
            onPress={() => nextPage()}
          />
        </ScrollView>
      </View>
    </View>
  );
};

export default LevelTwo;
